export default [{"tag":"path","att":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.998 13v4h2v-4h4v-2h-4V7h-2v4h-4v2h4z"}}]